import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchSingleActivedFlow } from "../../state/activedFlows/reducers";
import { useGantt } from "../../hooks/useGantt";
import { toastAlert } from "../../components/Toastify/index";
import { Body, Container, Footer, Header } from "./styles";
import { GanttTimeLine } from "../../components/GanttTimeLine";
import { PDFDownloadLink, Document } from "@react-pdf/renderer";
import { ExportButton } from "./ExportButton";
import { ProtectedComponent } from "../../components/general/Protected";
import { CSVLink } from "react-csv";
import DropSelectVersion from "../../components/general/DropSelectVersion";
import User from "../../components/general/UserAvatar";
import TasksLister from "./TasksLister";
// import PageSelector from "./PageSelector";
import ProductivityList from "./Productivity";
import BurndownChart from "./BurnDownChart";
import TasksPDF from "./TasksLister/PDF";
import ProductivityPDF from "./Productivity/PDF";
import Loading from "../../components/LoadingTemplate/index";
import { notificationNavigatePane } from "../../components/Notifications/BellComponent/utils";
import { BellComponent } from "../../components/Notifications/BellComponent";

const getStatus = (task) => {
  const status = task.status;

  return status === "doing"
    ? "Em execução"
    : status === "pending"
      ? "Pendente"
      : status === "done"
        ? "Concluído"
        : status === "doneLate"
          ? "Concluído com atraso"
          : "Atrasado";
};

const PDFDocument = ({ jobs }) => {
  return (
    <Document>
      <TasksPDF jobs={jobs} />
      <ProductivityPDF jobs={jobs} />
    </Document>
  );
};

const CSVDocument = (jobs) =>
  jobs
    .filter((item) => item.type === "task")
    .map(
      (task) =>
        (task = {
          nome: task.label,
          data_de_inicio: task.start,
          duracao: task.duration.number,
          data_de_termino: task.end,
          status: getStatus(task),
          responsavel: task.accountable ? task.accountable.username : null,
        }),
    );

const AdvancedStats = () => {
  const user = useSelector((state) => state.auth.user);
  const pane = useSelector((state) => state.activedFlows.pane);

  const dispatch = useDispatch();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const status = pane.status;
  const activedFlow = pane.flow;
  const { unMountedLoadGantt } = useGantt();

  const [openExport, setOpenExport] = useState(false);
  const [page, setPage] = useState("produtividade");

  const redirectionWorkflowFunctions = {
    task_mention: notificationNavigatePane,
  };

  const fetchingData = () => {
    if (user) {
      dispatch(
        fetchSingleActivedFlow({
          tenantId: !user.tenantId ? user?._id : user.tenantId,
          _id: params.get("flowId"),
        }),
      ).then((res) => {
        if (res.error) {
          toastAlert({
            msg: `Ocorreu um ERRO ao carregar o Fluxo Ativo: ${res.payload.error} - CODE: ${res.payload.code}`,
            isError: true,
          });
        }
      });
    }
  };
  const { jobs, status: ganttStatus } = useGantt();

  useEffect(() => {
    let isMounted = true;
    if (isMounted && status !== "succeeded") {
      fetchingData();
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let isMounted = true;
    if (status === "succeeded" && isMounted) {
      unMountedLoadGantt(
        activedFlow.elements,
        activedFlow._id,
        activedFlow.flowStatus,
        activedFlow.createdAt,
      );
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const exportOptions = [
    {
      format: ".pdf",
      link: (
        <PDFDownloadLink
          document={<PDFDocument jobs={jobs} />}
          fileName={`${pane.flow.title}.pdf`}
        >
          {(e) => {
            return (
              <span style={{ width: "100%", display: "block" }}>.pdf</span>
            );
          }}
        </PDFDownloadLink>
      ),
    },
    {
      format: ".csv",
      link: (
        <CSVLink filename={`${pane.flow.title}.csv`} data={CSVDocument(jobs)}>
          <span style={{ width: "100%", display: "block" }}>.csv</span>
        </CSVLink>
      ),
    },
    { name: "Imprimir", click: () => window.print() },
  ];

  const loadingStatus =
    status === "succeeded" && ganttStatus === "done" ? true : false;

  return (
    <>
      {loadingStatus ? (
        <Container>
          <DropSelectVersion
            title={pane.flow.title}
            editable={false}
            selector={false}
            AdvancedStats={true}
          />
          <Header>
            <ProtectedComponent callback={() => page === "produtividade"}>
              <ExportButton
                style={{ marginRight: "2rem" }}
                openState={[openExport, setOpenExport]}
                options={exportOptions}
              />
            </ProtectedComponent>
            <BellComponent
              style={{ marginRight: "2rem" }}
              redirectionFunctions={redirectionWorkflowFunctions}
            />
            <User />
          </Header>
          {/* <PageSelector jobs={jobs} page={page} setPage={setPage} /> */}
          {page === "produtividade" ? (
            <>
              <Body>
                <BurndownChart elements={activedFlow.elements} />
                <ProductivityList />
              </Body>
              <Footer>
                <TasksLister jobs={jobs} />
              </Footer>
            </>
          ) : (
            <GanttTimeLine />
          )}
        </Container>
      ) : (
        <Loading />
      )}
    </>
  );
};

export default AdvancedStats;
